$(document).ready(() => {

    const swiperEvent = () => {

		let swiper = new Swiper('.swiper-container', {
			centeredSlides: true,
			centeredSlidesBounds: true,
			slidesPerView: 'auto',
			spaceBetween: 20,
			breakpoints: {
				1092: {
					init: false,
					allowSlidePrev: false,
					allowSlideNext: false

				}
			}
		});

    }

    swiperEvent();

});
